module.exports = __webpack_public_path__ + "fepro/img/indexHeader.0f6633dd.png";